<template>
  <div class="module dt-top">
    <div
      class="dt-top-bg"
      @click="preventThis(e)"
    >
      <img :src="itemData.v_picurl">
      <div class="mask" />
    </div>
    <div class="dt-wrap">
      <header class="dt-header">
        <a
          v-show="backStatus"
          class="back"
          uigs="head_back"
          @click="backPrev"
        />
        <h1>{{ headTitle }}</h1>
        <a
          :href="'/?source=node&spver=' + spver"
          class="home"
          uigs="head_home"
        />
        <a
          :href="'/hotsugg?spver=' + spver"
          class="search"
          uigs="head_search"
        />
      </header>
      <div class="dt-info-header-wap">
        <div class="dt-info-img">
          <Image-1
            :src="itemData.vpicurl ? vpicurl : itemData.v_picurl"
            :iname="itemData.name + '剧照'"
          />
          <span
            v-if="itemData.play_status === '2'"
            class="tag-vip"
          >VIP</span>
          <span class="tag-mark">{{ formatScore(itemData.score) }}</span>
        </div>
        <figure class="dt-info-box">
          <figcaption>{{ itemData.name }}</figcaption>
          <p :class="[playInfoStatus ? 'dt-info-tag' : 'dt-info-tag two-line']">
            <template v-for="(v, index) in infolist">
              <span :key="'info' + index">{{ v }}</span>
              <em
                v-if="index !== infolist.length - 1"
                :key="'info_' + index"
              >/</em>
            </template>
          </p>
          <template v-if="text">
            <p :class="[playInfoStatus ? 'dt-info-tag' : 'dt-info-tag two-line']">
              <span v-if="typeof itemData.starring !== 'undefined'">主演：</span>
              <span v-else-if="typeof itemData.emcee !== 'undefined'">主持：</span>
              <span v-else-if="typeof itemData.shengyou !== 'undefined'">声优：</span>
              <template v-for="(str, index) in text.split(';')">
                <em
                  v-if="index !== 0"
                  :key="'playinfo' + index"
                >&nbsp;</em>
                <a
                  :key="'playinfo_' + index"
                  :href="searchResultUrl(str)"
                  uigs="basic_out"
                >{{ str }}</a>
              </template>
            </p>
          </template>
          <template v-if="itemData.director">
            <p :class="[playInfoStatus ? 'dt-info-tag' : 'dt-info-tag two-line']">
              <span v-if="type === 'cartoon'">作者：</span>
              <span v-else>导演：</span>
              <template v-for="(str, index) in itemData.director.split(';')">
                <em
                  v-if="index !== 0"
                  :key="'director' + index"
                >&nbsp;</em>
                <a
                  :key="'director_' + index"
                  :href="searchResultUrl(str)"
                  uigs="basic_out"
                >{{ str }}</a>
              </template>
            </p>
          </template>
          <p
            v-if="itemData.update_wordstr"
            class="dt-info-tag"
          >
            <span>更新时间：</span>
            <span>{{ itemData.update_wordstr }}</span>
          </p>
          <p
            v-if="itemData.tv_station"
            id="tv_station"
            class="dt-info-tag"
          >
            <span>电视台：</span>
            <span>{{ itemData.tv_station }}</span>
          </p>
          <p
            v-if="itemData.release_time && isShowReleaseTime"
            id="release_time"
            class="dt-info-tag"
          >
            <span>上映时间：</span>
            <span>{{ itemData.release_time }}</span>
          </p>
          <div class="dt-play-btn">
            <div class="dt-play-btn">
              <div
                v-if="playInfo.length >= 1"
                id="dt-site-source"
                class="dt-source"
                @click="showSiteList"
              >
                <p :class="['dt-source-item', 'first', playInfo.length === 1 ? 'hide' : '']">
                  <img
                    v-if="initPlayInfo.icon"
                    :src="itemData.imgpath + '/logo/' + initPlayInfo.icon"
                  >
                  <span class="dt-source-item-first">{{ initPlayInfo.siteName }}</span>
                </p>
              </div>
              <div
                v-if="playInfo.length > 0"
                v-show="playInfoStatus"
                class="dt-info-box-btm"
              >
                <a
                  class="btn"
                  :href="initPlayInfo.url"
                  :uigs="itemData.play_status === '3' ? 'preview_play' : 'btn_play'"
                  :uigsparams="`play_type=lvideo&play_url=${encodeURIComponent(initPlayInfo.ourl)}&play_site=${
                    initPlayInfo.domain
                  }`"
                >
                  {{ itemData.play_status === '3' ? '预告片' : '立即播放' }}
                </a>
              </div>
            </div>
          </div>
          <template v-if="playInfo.length > 1">
            <LayerSelect
              :list-data="playInfo"
              :select-title="'选择来源'"
              :cur-data="initPlayInfo"
              :get-name="getSiteName"
              :get-icon="getSiteIcon"
              :layer-show="isSiteListShow"
              @change-list-item="changePlayInfo"
              @hidden-layer="hiddenLayer"
            />
          </template>
        </figure>
      </div>
      <div
        v-show="itemData.introduction"
        :class="['dt-info-intro', { fold: isFold === true }, { hideIntro: itemData.hideIntro === 1 }]"
      >
        <div
          v-if="itemData.introduction && itemData.introduction.trim()"
          class="con"
        >
          <p
            v-show="itemData.hideIntro !== 1"
            @click="toggleFold(itemData.introduction)"
          >
            <em v-if="itemData.introduction && itemData.introduction.trim()">剧情简介 : </em>{{ itemData.introduction }}
          </p>
          <p
            v-if="itemData.alais_name.length > 0 && false"
            class="other-name"
          >
            <em>别名 : </em>
            <a
              v-for="(v, index) in itemData.alais_name"
              :key="'alais' + index"
              :href="v.url"
              :title="v.name"
              uigs="alias_out"
            >
              <span> {{ v.name }};</span>
            </a>
          </p>
          <a
            v-if="dockey.indexOf('film_') > -1 && plotInfo && plotInfo.show && false"
            :href="'/s/plot/' + dockey + '.html'"
          >
            查看完整剧情
          </a>
        </div>
        <div
          v-if="getByteLength(itemData.introduction) > 102 && +itemData.hideIntro !== 1"
          class="dt-info-intro-more"
          @click="toggleFold(itemData.introduction)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '@types';
import { mapMutations, mapState } from 'vuex';

import LayerSelect from '../../common/components/LayerSelect';
import { getSpver } from '../../common/js/util';
import Image from './Image.vue';

export default {
  components: {
    'Image-1': Image,
    LayerSelect,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      language: '',
      headTitle: this.title,
      isSiteListShow: false,
      isFold: true,
      siteIsFold: 'none',
      backStatus: false,
      chosedSite: '',
    };
  },
  computed: {
    ...mapState('detail', ['itemData', 'playInfoIndex']),
    item() {
      return this.itemData;
    },
    dockey() {
      return this.itemData.dockey || '';
    },
    playInfo() {
      return this.itemData.playInfo || [];
    },
    initPlayInfo() {
      const info = this.itemData.playInfo
        && this.itemData.playInfo.length > 0
        ? this.itemData.playInfo[this.playInfoIndex]
        : {};
      return info;
    },
    type() {
      const data = this.itemData;
      let { type } = data;
      if (type === 'series') {
        if (data.dockey.startsWith('teleplay')) {
          type = 'teleplay';
        } else if (data.dockey.startsWith('cartoon')) {
          type = 'cartoon';
        }
      }
      return type;
    },
    playInfoStatus() {
      const p = this.itemData.playInfo;
      if (p && Object.values(p).length > 0) {
        return true;
      }
      return false;
    },
    text() {
      const item = this.itemData;
      if (item.starring) {
        return item.starring;
      }
      if (item.emcee) {
        return item.emcee;
      }
      if (item.shengyou) {
        return item.shengyou;
      }
      return '';
    },
    infolist() {
      const item = this.itemData;
      const list = [];
      if (item.year) {
        list.push(item.year);
      }
      if (item.zone) {
        const v = item.zone.split(';')[0];
        list.push(v);
      }
      if (item.style) {
        if (this.playInfo && this.playInfo.length > 0) {
          const s = item.style.split(';').slice(0, 2);
          list.push(s.join(' '));
        } else {
          const s = item.style.replace(/;/g, ' ');
          list.push(s);
        }
      }
      if (item.duration && item.duration !== '0') {
        list.push(`${item.duration}分钟`);
      }
      return list;
    },
    plotInfo() {
      const { plotInfo } = this.itemData;
      if (plotInfo) {
        const { content = '' } = plotInfo;
        return content;
      }
      return '';
    },
    isShowReleaseTime() {
      const item = this.itemData;
      const mainTitle = item.isAlias ? item.oquery : item.name;
      if (this.getByteLength(mainTitle) <= 20 && this.playInfo && this.playInfo.length === 0) {
        return true;
      }
      return false;
    },
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || '';
    },
  },
  mounted() {
    const self = this;
    const data = self.itemData;
    const { history } = window;
    // 展开简介
    if (data && data.introUnfold) {
      // data.introUnfold为 number 类型
      const { introUnfold } = data;
      if (introUnfold === 1) {
        self.isFold = false;
      }
    }

    // 初始化选中的站点名称
    if (self.initPlayInfo && self.initPlayInfo.siteName) {
      self.chosedSite = self.initPlayInfo.siteName;
    }
    // 返回按钮处理逻辑
    const uigsUa = navigator.userAgent.toLowerCase();
    const isSogouAPP = uigsUa.indexOf('sogousearch') >= 0;
    const len = isSogouAPP ? 1 : 0;
    const { search } = window.location;
    if (search && search.indexOf('_bs=1') > -1) {
      self.backStatus = false;
    } else if (history.length > len && document.referrer) {
      self.backStatus = true;
    } else if (isSogouAPP) {
      let rurl = window.location.href;
      if (search !== '' && typeof search !== 'undefined') {
        rurl += '&_bs=1';
      } else {
        rurl += '?_bs=1';
      }
      history.replaceState(null, null, rurl);
    }

    if (window.screen.width && window.screen.width <= 320) {
      // 小屏且存在播放按钮隐藏两条信息
      if (self.playInfo && self.playInfo.length >= 0) {
        if (document.querySelector('#tv_station')) {
          document.querySelector('#tv_station').style.display = 'none';
        }
        if (document.querySelector('#release_time')) {
          document.querySelector('#release_time').style.display = 'none';
        }
      }
    }
  },
  methods: {
    ...mapMutations('detail', [types.UPDATE_PLAYINFOINDEX, types.UPDATE_ADV]),
    preventThis(e) {
      if (e) {
        e.preventDefault();
      }
    },
    toggleFold(str) {
      if (str && this.getByteLength(str) > 102) {
        this.isFold = !this.isFold;
      }
    },
    getSiteName(item) {
      return item.siteName;
    },
    getSiteIcon(item) {
      return item.icon;
    },
    async changePlayInfo(item, index) {
      const v = item;
      this[types.UPDATE_PLAYINFOINDEX](index);
      event.stopPropagation();
      this.isSiteListShow = false;
      // 若选中已选站点，则不发adv请求
      if (v.siteName === this.chosedSite) {
        return;
      }
      this.chosedSite = v.siteName;
    },
    hiddenLayer(event) {
      this.isSiteListShow = false;
      if (event) {
        event.stopPropagation();
      }
    },
    showSiteList() {
      if (this.playInfo.length <= 1) {
        return;
      }
      this.isSiteListShow = true;
    },
    backPrev() {
      history.go(-1);
      return false;
    },
    searchResultUrl(string) {
      return `https://m.sogou.com/web/searchList.jsp?keyword=${string}&ie=utf8&pid=sogou-waps-4c26774d852f6244`;
    },
    formatScore(str) {
      return str && str.indexOf('.') === -1 ? `${str}.0` : str;
    },
    getByteLength(str) {
      if (str) {
        // eslint-disable-next-line no-control-regex
        const byteStr = str.toString().replace(/[^\x00-\xff]/gi, '01');
        return byteStr.length;
      }
      return 0;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';
.dt-top {
  padding: 0 14px 35px;
  position: relative;
  margin-bottom: 2px;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 100%;
    height: 23px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: #fff;
  }
}

.dt-top-bg {
  overflow: hidden;
  position: absolute;
  bottom: 0;
  right: 0;
  top: 0;
  left: 0;
  z-index: -1;
  border-bottom: 1px solid #fff;
  img {
    width: 130%;
    filter: blur(100px);
    -webkit-filter: blur(100px); /* Chrome, Opera */
    -moz-filter: blur(100px);
    -ms-filter: blur(100px);
    vertical-align: top;
    position: absolute;
    transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    left: -10%;
    top: -100px;
  }

  .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 3;
  }
}

.dt-wrap {
  z-index: 2;
}

.dt-info-header-wap {
  display: flex;
}

.dt-header {
  height: 57px;
  line-height: 57px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  position: relative;

  h1 {
    opacity: 0.7;
  }

  .back {
    @include sprite-item('detail/back');
    @extend %-vertical-center;
    left: 0;
    z-index: 9999;
  }
  .collect {
    @include sprite-item('detail/collect');
    @extend %-vertical-center;
    right: 0;
  }
  .home {
    @include sprite-item('detail/home');
    @extend %-vertical-center;
    right: 51px;
  }
  .search {
    @include sprite-item('detail/search');
    @extend %-vertical-center;
    right: 6px;
  }
}

.dt-info-box {
  color: #fff;
  position: relative;
  width: 60%;
  figcaption {
    @include line-clip(2);
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 8px;
    margin-top: -2px;
    font-weight: bold;
  }
  @media screen and (max-width: 330px) {
    .dt-info-tag:nth-child(n + 3) {
      display: none;
    }
  }
  @media screen and (max-width: 380px) {
    .dt-info-tag:nth-child(n + 4) {
      display: none;
    }
  }

  .dt-play-btn {
    height: 68px;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}

.dt-info-box-btm {
  margin-top: 12px;
  height: 40px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  .btn {
    background: #fff;
    border-radius: 3px;
    height: 40px;
    line-height: 40px;
    width: 100%;
    text-align: center;
    color: #222;
    font-size: 15px;
    display: inline-block;
    &:before {
      display: inline-block;
      content: '';
      @include sprite-item('detail/icon_play');
      width: 15px;
      height: 15px;
      margin-bottom: -2px;
    }
  }
}

.dt-info-tag {
  @include line-clip(1);
  margin-bottom: 7px;
  color: #fff;
  font-size: 13px;
  padding-top: 1px;

  &.two-line {
    @include line-clip(2);
    line-height: 19px;
    white-space: normal;
    margin-bottom: 1px;
    display: -webkit-box;
  }

  a {
    color: #fff;
    font-size: 13px;
  }

  em {
    margin-right: 2px;
  }
}

.dt-info-img {
  width: 38%;
  padding-bottom: 54%;
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 12px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  min-height: 158px;
  box-sizing: border-box;
  &:after {
    content: '';
    width: 100%;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }

  img {
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    object-fit: cover;
  }

  > span {
    position: absolute;
    display: block;
  }

  > div {
    width: 100%;
    height: 100%;
  }
  .tag-vip {
    padding: 2px 5px;
    border-radius: 3px;
    background: linear-gradient(to bottom, #ff8e33, #ff7219);
    font-size: 12px;
    color: #fff;
    font-weight: bold;
    right: 6px;
    top: 6px;
  }

  .tag-mark {
    right: 8px;
    bottom: 10px;
    color: #fece32;
    font-size: 13px;
    z-index: 2;
    font-weight: bold;

    &:first-letter {
      font-size: 19px;
    }
  }
}

.dt-info-intro {
  margin-top: 25px;
  font-size: 13px;
  color: #fff;
  width: 100%;
  position: relative;
  height: auto;
  line-height: 21px;

  .con p {
    opacity: 0.7;

    &.other-name {
      margin-top: 14px;
    }
  }

  span {
    width: 100%;
  }

  a {
    color: #fff;
  }
  &.hideIntro {
    margin-top: 19px;
    margin-bottom: 9px;
  }
  &.fold {
    .con {
      height: 38px;
      overflow: hidden;
    }

    p {
      @include line-clip(2);
      display: -webkit-box;
    }

    .dt-info-intro-more:before {
      transform: rotate(-180deg);
      -ms-transform: rotate(-180deg); /* IE 9 */
      -moz-transform: rotate(-180deg); /* Firefox */
      -webkit-transform: rotate(-180deg); /* Safari 和 Chrome */
      -o-transform: rotate(-180deg); /* Opera */
    }
  }
}
.dt-info-intro-more {
  width: 100%;
  position: relative;
  height: 28px;

  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('detail/arrow');
  }
}

.dt-source {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.source-cur {
  display: flex;
  align-items: center;
  .dt-source-item {
    span {
      font-size: 15px;
      font-weight: bold;
      color: rgba(34, 34, 34, 1);
    }
  }
  &:after {
    margin-top: -2px;
    position: absolute;
    right: 16px;
    display: block;
    content: '';
    width: 5px;
    height: 9px;
    border-color: #555555;
    border-style: solid;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
  }
}
.dt-source-item {
  img {
    width: 13px;
    height: 13px;
    vertical-align: middle;
  }
  .dt-source-item-first {
    font-size: 13px;
    color: rgba(255, 255, 255, 1);
    line-height: 19px;
    display: inline-block;
  }
  span {
    display: inline-block;
    font-size: 15px;
    color: rgba(153, 153, 153, 1);
    line-height: 48px;
  }

  &.first {
    &:after {
      @include arr(4px, 135deg, #fff);
      display: inline-block;
      vertical-align: middle;
      content: '';
      margin-left: 9px;
    }
    &.hide {
      &:after {
        display: none;
      }
    }
  }
}
</style>
